// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared semantic colors for the editor, including its reused quotation controls.
   Scope to the editor so customer documents and other journeys keep their styles. */
.invoice-flow-shell.invoice-editor-shell {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(h1, h2, h3, .invoice-flow-card label, .invoice-item-actions
    strong, .invoice-summary-card strong, .invoice-total-card
    > strong, .quotation-editor-subtitle strong, .quotation-meta-attribution
    strong) {
  color: var(--text-primary);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-editor-intro, .invoice-editor-intro span, .invoice-flow-card
    > p, .invoice-flow-card > small, .invoice-section-title
    p, .invoice-pricing-basis, .invoice-draft-footnote, .invoice-summary-card
    > p
    span, .invoice-attachment-box p, .invoice-source-banner
    span, .invoice-item-actions
    > span, .quotation-field-footnote, .quotation-editor-subtitle, .quotation-meta-attribution, .quotation-item-discount-row
    label) {
  color: var(--text-secondary);
}

.invoice-flow-shell.invoice-editor-shell .invoice-flow-card {
  background: var(--surface-primary);
  border-color: var(--border-subtle);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-flow-card input, .invoice-flow-card select, .invoice-flow-card
    textarea) {
  color: var(--text-primary);
  caret-color: var(--text-primary);
  border-color: var(--border-default);
}

.invoice-editor-shell .invoice-flow-card > label > :is(input, textarea),
.invoice-editor-shell .invoice-fields label > :is(input, textarea) {
  background: var(--surface-primary);
}

.invoice-editor-shell .invoice-editor-page :is(input, textarea)::placeholder {
  color: var(--text-tertiary);
  opacity: 1;
}

.invoice-editor-shell .invoice-editor-page :is(input, select, textarea):focus {
  border-color: var(--focus-ring);
  box-shadow: none;
}

.invoice-editor-shell .invoice-editor-page input[readonly] {
  color: var(--text-secondary);
  background: var(--surface-secondary);
}

.invoice-editor-shell.dark .invoice-editor-page
  :is(.invoice-date-picker-field .figma-datepicker__input-container,
    .invoice-date-follow-up > input[readonly]) {
  background-color: var(--surface-primary) !important;
}

.invoice-editor-shell
  .invoice-editor-page
  :is(input, select, textarea):disabled {
  color: var(--text-disabled);
  -webkit-text-fill-color: var(--text-disabled);
  background: var(--surface-secondary);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-attachment-box, .quotation-attachment-item) {
  background: var(--surface-secondary);
  border-color: var(--border-subtle);
  color: var(--text-primary);
}

.invoice-editor-shell .invoice-editor-page .invoice-source-banner {
  background: var(--interactive-soft);
  border-color: var(--border-subtle);
  color: var(--interactive-default);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-summary-card
    hr, .invoice-edit-item, .quotation-editor-meta-bar) {
  border-color: var(--border-subtle);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-flow-back, .invoice-text-action, .invoice-pricing-basis
    span, .invoice-total-card svg, .invoice-attachment-box
    > svg, .quotation-action-link-btn, .quotation-attachment-view-btn) {
  color: var(--interactive-default);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-editor-actions button:not(.primary), .invoice-item-actions
    button, .quotation-action-outline-btn, .invoice-doc-action:not(.download)) {
  background: var(--surface-primary);
  color: var(--text-primary);
  border-color: var(--border-default);
}

.invoice-editor-shell .invoice-editor-page .invoice-upload-button {
  background: var(--surface-secondary);
  border-color: var(--border-default);
  /* Override the legacy upload label's important light text rule. */
  color: var(--text-primary) !important;
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-editor-actions button:not(.primary), .invoice-item-actions
    button, .quotation-action-outline-btn, .invoice-upload-button):hover:not(:disabled) {
  background: var(--surface-secondary);
  border-color: var(--border-strong);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-editor-actions button.primary, .invoice-delivery-card > button) {
  background: var(--interactive-default);
  border-color: var(--interactive-default);
  color: var(--on-interactive-primary);
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.invoice-editor-actions button.primary, .invoice-delivery-card
    > button):hover:not(:disabled) {
  background: var(--interactive-hover);
  border-color: var(--interactive-hover);
}

.invoice-editor-shell .invoice-editor-page :is(button, a):focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.invoice-editor-shell
  .invoice-editor-page
  :is(.quotation-field-error, .invoice-flow-card label > em) {
  color: var(--danger-text);
}

.invoice-editor-shell .invoice-editor-page [aria-invalid="true"] {
  border-color: var(--danger-default);
}

.invoice-editor-shell .invoice-editor-page .quotation-attachment-remove-btn {
  color: var(--danger-text);
}

.invoice-editor-shell
  .invoice-editor-page
  .quotation-attachment-remove-btn:hover {
  background: var(--danger-soft);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Invoices/invoiceEditorTheme.css"],"names":[],"mappings":"AAAA;oFACoF;AACpF;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;;;;;;;;;;EAUE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;;;;EAIE,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;;;EAGE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA;;;;EAIE,kCAAkC;EAClC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,kEAAkE;EAClE,qCAAqC;AACvC;;AAEA;;;;EAIE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;;EAGE,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;AAChC","sourcesContent":["/* Shared semantic colors for the editor, including its reused quotation controls.\n   Scope to the editor so customer documents and other journeys keep their styles. */\n.invoice-flow-shell.invoice-editor-shell {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(h1, h2, h3, .invoice-flow-card label, .invoice-item-actions\n    strong, .invoice-summary-card strong, .invoice-total-card\n    > strong, .quotation-editor-subtitle strong, .quotation-meta-attribution\n    strong) {\n  color: var(--text-primary);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-editor-intro, .invoice-editor-intro span, .invoice-flow-card\n    > p, .invoice-flow-card > small, .invoice-section-title\n    p, .invoice-pricing-basis, .invoice-draft-footnote, .invoice-summary-card\n    > p\n    span, .invoice-attachment-box p, .invoice-source-banner\n    span, .invoice-item-actions\n    > span, .quotation-field-footnote, .quotation-editor-subtitle, .quotation-meta-attribution, .quotation-item-discount-row\n    label) {\n  color: var(--text-secondary);\n}\n\n.invoice-flow-shell.invoice-editor-shell .invoice-flow-card {\n  background: var(--surface-primary);\n  border-color: var(--border-subtle);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-flow-card input, .invoice-flow-card select, .invoice-flow-card\n    textarea) {\n  color: var(--text-primary);\n  caret-color: var(--text-primary);\n  border-color: var(--border-default);\n}\n\n.invoice-editor-shell .invoice-flow-card > label > :is(input, textarea),\n.invoice-editor-shell .invoice-fields label > :is(input, textarea) {\n  background: var(--surface-primary);\n}\n\n.invoice-editor-shell .invoice-editor-page :is(input, textarea)::placeholder {\n  color: var(--text-tertiary);\n  opacity: 1;\n}\n\n.invoice-editor-shell .invoice-editor-page :is(input, select, textarea):focus {\n  border-color: var(--focus-ring);\n  box-shadow: none;\n}\n\n.invoice-editor-shell .invoice-editor-page input[readonly] {\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n}\n\n.invoice-editor-shell.dark .invoice-editor-page\n  :is(.invoice-date-picker-field .figma-datepicker__input-container,\n    .invoice-date-follow-up > input[readonly]) {\n  background-color: var(--surface-primary) !important;\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(input, select, textarea):disabled {\n  color: var(--text-disabled);\n  -webkit-text-fill-color: var(--text-disabled);\n  background: var(--surface-secondary);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-attachment-box, .quotation-attachment-item) {\n  background: var(--surface-secondary);\n  border-color: var(--border-subtle);\n  color: var(--text-primary);\n}\n\n.invoice-editor-shell .invoice-editor-page .invoice-source-banner {\n  background: var(--interactive-soft);\n  border-color: var(--border-subtle);\n  color: var(--interactive-default);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-summary-card\n    hr, .invoice-edit-item, .quotation-editor-meta-bar) {\n  border-color: var(--border-subtle);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-flow-back, .invoice-text-action, .invoice-pricing-basis\n    span, .invoice-total-card svg, .invoice-attachment-box\n    > svg, .quotation-action-link-btn, .quotation-attachment-view-btn) {\n  color: var(--interactive-default);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-editor-actions button:not(.primary), .invoice-item-actions\n    button, .quotation-action-outline-btn, .invoice-doc-action:not(.download)) {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border-color: var(--border-default);\n}\n\n.invoice-editor-shell .invoice-editor-page .invoice-upload-button {\n  background: var(--surface-secondary);\n  border-color: var(--border-default);\n  /* Override the legacy upload label's important light text rule. */\n  color: var(--text-primary) !important;\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-editor-actions button:not(.primary), .invoice-item-actions\n    button, .quotation-action-outline-btn, .invoice-upload-button):hover:not(:disabled) {\n  background: var(--surface-secondary);\n  border-color: var(--border-strong);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-editor-actions button.primary, .invoice-delivery-card > button) {\n  background: var(--interactive-default);\n  border-color: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.invoice-editor-actions button.primary, .invoice-delivery-card\n    > button):hover:not(:disabled) {\n  background: var(--interactive-hover);\n  border-color: var(--interactive-hover);\n}\n\n.invoice-editor-shell .invoice-editor-page :is(button, a):focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  :is(.quotation-field-error, .invoice-flow-card label > em) {\n  color: var(--danger-text);\n}\n\n.invoice-editor-shell .invoice-editor-page [aria-invalid=\"true\"] {\n  border-color: var(--danger-default);\n}\n\n.invoice-editor-shell .invoice-editor-page .quotation-attachment-remove-btn {\n  color: var(--danger-text);\n}\n\n.invoice-editor-shell\n  .invoice-editor-page\n  .quotation-attachment-remove-btn:hover {\n  background: var(--danger-soft);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
